function t(r) {
  var e = -1, a = Array(r.size);
  return r.forEach(function(n) {
    a[++e] = n;
  }), a;
}
export {
  t as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_setToArray.js
// module id = 1502
// module chunks = 41